var React = require('react');

function ProductsServices (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17.5 9.152H5.862A1.25 1.25 0 0 0 4.629 10.6l1.268 7.908a1.25 1.25 0 0 0 1.235 1.052H17.095a1.25 1.25 0 0 0 1.234-1.052l1.268-7.908a1.25 1.25 0 0 0-1.234-1.448H17.5zm.577-2.77-.265 1.27h.551a2.75 2.75 0 0 1 2.716 3.185l-1.27 7.909a2.75 2.75 0 0 1-2.714 2.314H7.132a2.75 2.75 0 0 1-2.716-2.314l-1.268-7.909a2.75 2.75 0 0 1 2.715-3.185h.552l-.264-1.27a2.75 2.75 0 0 1 2.692-3.31h6.542a2.75 2.75 0 0 1 2.692 3.31zm-10.13 1.27L7.62 6.077A1.25 1.25 0 0 1 8.843 4.57h6.542a1.25 1.25 0 0 1 1.223 1.506l-.328 1.575H7.948zm1.436 2.962a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm6.462 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z","fill":"#fff"}));
}

ProductsServices.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ProductsServices;

ProductsServices.default = ProductsServices;
